<template>
  <Component
    :is="as"
    :disabled="isLoading"
    type="button"
    class="relative inline-flex items-center justify-center rounded-full border border-background bg-primary px-3 py-1 font-medium text-primary-fg hover:bg-primary/70 focus:z-10 focus:outline-none disabled:pointer-events-none disabled:opacity-40"
  >
    <slot></slot>
    <BaseInnerLoading v-if="isLoading" />
  </Component>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    as?: "button" | "a"
    isLoading?: boolean
  }>(),
  { as: "button" }
)
</script>
